import React, { useState } from "react";
import { Navbar } from "flowbite-react";
import { Link } from "react-router-dom";
// import useStore from "../hook/store";
import auth from "../services/auth";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge } from "@mui/material";
import { user } from "../common/type";
import api from "../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { changePassword } from "../validations/Validation";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";

interface ChangePassword {
  id: number;
  oldPassword: string;
  password: string;
  confirmPassword: string;
}

const Header = (props: {
  user: user;
  setUser: (us: user | null) => void;
  notFCount: number;
}) => {
  // const [theme, setTheme] = useState("");
  // const { user, reset } = useStore()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { user, setUser, notFCount } = props;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    console.log("clicked");
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   if (!window.matchMedia("(prefers-color-scheme: dark)").matches) {
  //     setTheme("dark");
  //   } else {
  //     setTheme("light");
  //   }
  // }, []);

  // useEffect(() => {
  //   if (theme === "dark") {
  //     document.documentElement.classList.add("dark");
  //   } else {
  //     document.documentElement.classList.remove("dark");
  //   }
  // }, [theme]);

  // useEffect(() => {
  //   i18n.changeLanguage("en");
  // }, [i18n]);
  const [chOpen, setChOpen] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ChangePassword>({
    resolver: yupResolver(changePassword),
  });

  const onSubmit = (data: ChangePassword) => {
    const load = toast.loading("Please wait...");

    auth
      .changePassword(data)
      .then((res) => {
        toast.update(load, {
          render: res.data,
          type: "success",
          theme: "colored",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setChOpen(false);
      })
      .catch((err) => {
        console.log(err);
        toast.update(load, {
          render: err?.response?.data || "Something went wrong",
          theme: "colored",
          autoClose: 5000,
          type: "error",
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setChOpen(false);
      });
  };

  return (
    <>
      <Navbar fluid rounded className="bg-amber50 dark:bg-gray-900">
        <Navbar.Brand>
          <Link to="/">
            <img
              alt={"DentalClinicLogo"}
              className="mr-3 h-6 sm:h-9 rounded-full inline"
              src={require("../assets/images/teeth.jpg")}
            />
            <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
              Dental Clinic
            </span>
          </Link>
        </Navbar.Brand>
        <div className="flex flex-row items-center md:order-2">
          {user ? (
            <>
              <Link to="/notifications" className="mr-1 lg:mr-4">
                <Badge
                  badgeContent={
                    notFCount > 0 ? (notFCount > 50 ? "50+" : notFCount) : null
                  }
                  color="error"
                  className="hover:cursor-pointer"
                >
                  <NotificationsIcon />
                </Badge>
              </Link>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
              >
                {user.isSuperAdmin && (
                  <MenuItem>
                    <Link to={"/register/saas"}>SAAS</Link>
                  </MenuItem>
                )}
                <MenuItem
                  onClick={async () => {
                    handleClose();
                    reset();
                    setChOpen(true);
                  }}
                >
                  Change Password
                </MenuItem>
                <MenuItem
                  onClick={async () => {
                    handleClose();
                    setUser(null);
                    await auth.logout().catch((err) => {
                      console.log(err);
                    });
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
              <button
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                className="mr-1 lg:mr-4"
              >
                Hi {user.staff.firstName}
              </button>
            </>
          ) : (
            <Link to={"/login"}>SignIn</Link>
          )}
          <Navbar.Toggle />
        </div>
        {user ? (
          <Navbar.Collapse>
            <Link to="/">
              <Navbar.Link>Home</Navbar.Link>
            </Link>
            <Link to="/search/patient">
              <Navbar.Link>Search Patient</Navbar.Link>
            </Link>
            {user.roles.some((role) => role.name === "Admin") ? (
              <>
                <Link to="/staffs">
                  <Navbar.Link>Staffs</Navbar.Link>
                </Link>
                <Link to="/branches">
                  <Navbar.Link>Branches</Navbar.Link>
                </Link>
              </>
            ) : (
              <></>
            )}
            {user.roles.some(
              (role) => role.name === "Admin" || role.name === "Doctor",
            ) ? (
              <Link to="/treatments">
                <Navbar.Link>Treatments</Navbar.Link>
              </Link>
            ) : (
              <></>
            )}

            <Link to="/expected">
              <Navbar.Link>Expected Payments</Navbar.Link>
            </Link>

            <Link to="/transactions">
              <Navbar.Link>Transactions</Navbar.Link>
            </Link>
            {user?.roles.some((role) => role.name === "Admin") ? (
              <Link to="register" className="mr-4">
                <Navbar.Link>Register User</Navbar.Link>
              </Link>
            ) : (
              <></>
            )}
            {user?.isSuperAdmin ? (
              <Link to="users" className="mr-4">
                <Navbar.Link>Users</Navbar.Link>
              </Link>
            ) : (
              <></>
            )}
          </Navbar.Collapse>
        ) : (
          <></>
        )}
      </Navbar>
      {user && (
        <div className="flex flex-row items-center justify-center bg-gradient-to-r from-blue-300 to-green-400 p-3">
          <img
            alt={"DentalClinicLogo"}
            className="mr-3 h-6 sm:h-9 rounded-full inline"
            src={
              user.pic_url
                ? api.getUri() + user.pic_url
                : require("../assets/images/teeth.jpg")
            }
          />
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            {user.name}
          </span>
        </div>
      )}
      <Dialog open={chOpen} onClose={() => setChOpen(false)}>
        <DialogTitle align="center">Change Password</DialogTitle>
        <DialogContent>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="grid grid-cols-1 gap-3 py-3"
          >
            <input type="hidden" {...register("id")} value={user?.id} />
            <div>
              <div className="inline flex items-center w-full relative">
                <TextField
                  size="small"
                  {...register("oldPassword")}
                  type={isVisible1 ? "text" : "password"}
                  fullWidth
                  error={errors.oldPassword ? true : false}
                  label="Old Password"
                />
                {isVisible1 ? (
                  <VisibilityOffOutlined
                    className="absolute right-3 cursor-pointer"
                    onClick={() => setIsVisible1(false)}
                  />
                ) : (
                  <VisibilityOutlined
                    className="absolute right-3 cursor-pointer"
                    onClick={() => setIsVisible1(true)}
                  />
                )}
              </div>
              <p className="text-red-700 text-sm">
                {errors.oldPassword?.message}
              </p>
            </div>
            <div>
              <div className="inline flex items-center w-full relative">
                <TextField
                  size="small"
                  {...register("password")}
                  fullWidth
                  type={isVisible2 ? "text" : "password"}
                  error={errors.password ? true : false}
                  label="New Password"
                />
                {isVisible2 ? (
                  <VisibilityOffOutlined
                    className="absolute right-3 cursor-pointer"
                    onClick={() => setIsVisible2(false)}
                  />
                ) : (
                  <VisibilityOutlined
                    className="absolute right-3 cursor-pointer"
                    onClick={() => setIsVisible2(true)}
                  />
                )}
              </div>
              <p className="text-red-700 text-sm">{errors.password?.message}</p>
            </div>
            <div>
              <div className="inline flex items-center w-full relative">
                <TextField
                  size="small"
                  {...register("confirmPassword")}
                  fullWidth
                  type={isVisible3 ? "text" : "password"}
                  error={errors.confirmPassword ? true : false}
                  label="Confirm New Password"
                />
                {isVisible3 ? (
                  <VisibilityOffOutlined
                    className="absolute right-3 cursor-pointer"
                    onClick={() => setIsVisible3(false)}
                  />
                ) : (
                  <VisibilityOutlined
                    className="absolute right-3 cursor-pointer"
                    onClick={() => setIsVisible3(true)}
                  />
                )}
              </div>
              <p className="text-red-700 text-sm">
                {errors.confirmPassword?.message}
              </p>
            </div>
            <Button variant="outlined" type="submit">
              Change
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Header;
